import { render, staticRenderFns } from "./IndustryEdit.vue?vue&type=template&id=369d8503"
import script from "./IndustryEdit.vue?vue&type=script&lang=js"
export * from "./IndustryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports